import {Node, Element} from 'slate';
import * as SectionTypes from '../../../state/views/section/types';

export interface PanelGrid extends Element {
  type: 'panel-grid';
  metadata: SectionTypes.Config;
}

export const isPanelGrid = (node: Node): node is PanelGrid =>
  node.type === 'panel-grid';
